/**
 * Service: validate
 *
 * This service accepts an Array of { key: value } pairs where
 * the key == validatorName
 */
angular.module('acme.common.service.validate', [
  'acme.common.service.themesHelper'
])
.service('ValidateService', [ 'ThemesHelperService', function(ThemesHelperService) {

    /**
     * We don't check for string here so it also works with arrays
     * @returns {boolean}
     */
    function isEmptyInputValue(value) {
      return value === undefined || value === null || value.length === 0;
    }

    var EMAIL_REGEX = /(^(?!\s))[A-Z0-9a-z._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/;

    function emailValidator(value) {
      return EMAIL_REGEX.test(value);
    }

    function phoneValidator(value) {
      var stripped = (value) ? value.replace(/\D+/g, '') : '',
          valid = false;

      if ((/^\d{9,100}$/).test(stripped)) {
        valid = true;
      }

      return valid;
    }

    return {

      tests: [],

      init: function(tests) {
        if (tests instanceof Array) {
          this.tests = tests;
        }
        return true;
      },

      /**
       * Validate against an Array of Objects
       * Key must be the name of the validator
       *
       * @param list {Array<T>}
       * @returns {boolean}
       */
      validate: function(list) {

        var i, ii,
            key,
            keys,
            validatorName,
            validatorValue,
            validatorFunc,
            validatorField,
            validatorObject,
            customMessage;

        // Clear errors
        this.errors = [];

        this.passed = [];

        // Validate each element against its validator
        for (i=0,ii=list.length;i<ii;i++) {
          keys = [];
          validatorFunc = false;
          customMessage = false;
          validatorName = false;
          validatorValue = false;
          validatorObject = false;
          validatorField = false;

          for (key in list[i]) {
            if (list[i].hasOwnProperty(key)) {
              // If there is a field continue on and skip adding to keys array
              // We need this for when we respond to link back to originating field
              if (key === 'field') { continue; }
              // Only grab first key in object as it should be the validatorName
              keys.push(key);
              break;
            }
          }

          if (keys.length === 1) {
            // Expect the validator to be the first KEY in the array
            validatorName = keys[0];
            validatorObject = list[i][validatorName];

            if (list[i][validatorName]) {

              // Get validator and give it the value
              if (validatorObject.hasOwnProperty('message')) {
                customMessage = validatorObject.message;
                if (validatorObject.hasOwnProperty('test')) {
                  if (typeof(validatorObject.test) === 'function') {
                    validatorValue = validatorObject.test();
                  }else{
                    validatorValue = validatorObject.test;
                  }
                } else {
                  validatorValue = false;
                  this.errors.push({
                    validator: validatorName,
                    message: 'No test to run for validator `' + validatorName + '`'
                  });
                }
              }else{
                validatorValue = list[i][validatorName];
              }
            }

            validatorFunc = this.getValidator(validatorName);

            // If there is a validator and it fails
            if (validatorFunc && !validatorFunc(validatorValue)) {
              this.errors.push({
                validator: validatorName,
                message: (customMessage) ? customMessage : 'Invalid `' + validatorName + '`',
                payload: list[i]
              });
            }else if (!validatorFunc) {
              // If the function is not found add an error
              this.errors.push({
                validator: validatorName,
                message: 'No validator `' + validatorName + '` exists',
                payload: list[i]
              });
            }else{
              this.passed.push(list[i].field);
            }
          }else{
            this.errors.push({
              validator: false,
              message: 'Validator not found.',
              payload: list[i]
            });
          }

        }

        return (this.errors.length === 0);

      },

      /**
       * Get validator function
       *
       * @param name
       * @returns {boolean}
       */
      getValidator: function(name) {
        var validator;

        if (this.validators.hasOwnProperty(name)) {
          validator = this.validators[name];
        }

        return validator;
      },

      getPasswordMessage: function() {
        var passwordMessage = 'The password must be at least 8 characters long';

        if (ThemesHelperService.getCompany('passwordSecurityPolicyEnabled')) {
          if (ThemesHelperService.getCompany('passwordMinimumLength')) {
            passwordMessage = "The password must be at least " + ThemesHelperService.getCompany('passwordMinimumLength') + " characters long";
          }

          if (ThemesHelperService.getCompany('passwordUseMixedCase')) {
            passwordMessage = passwordMessage + ', use a mix of lower case and capital letters';
          }

          if (ThemesHelperService.getCompany('passwordMinimumDigits')) {
            passwordMessage = passwordMessage + ', at least one number';
          }

          if (ThemesHelperService.getCompany('passwordMinimumSymbols')) {
            passwordMessage = passwordMessage + ', at least one special character like _, !, # etc.';
          }
        }

        return passwordMessage;
      },

      getError: function(fieldName) {

        var i, ii,
          r = false;

        for (i=0,ii=this.errors.length;i<ii;i++) {
          if (this.errors[i].hasOwnProperty('payload') && this.errors[i].payload.field === fieldName) {
            r = this.errors[i];
            break;
          }
        }

        return r;

      },

      getErrorHash: function() {

        var i, ii,
          r = {};

        for (i=0,ii=this.errors.length;i<ii;i++) {
          if (this.errors[i].hasOwnProperty('payload')) {
            r[this.errors[i].payload.field] = this.errors[i];
          }
        }

        return r;

      },

      check: function(list, fieldName) {

        var i, ii,
          key,
          keys,
          validatorName,
          validatorValue,
          validatorFunc,
          validatorField,
          customMessage,
          errors = [];

        // Validate each element against its validator
        for (i=0,ii=list.length;i<ii;i++) {
          // Skip if it's not the field we're looking for
          keys = [];
          validatorFunc = false;
          customMessage = false;
          validatorName = false;
          validatorValue = false;
          validatorField = false;

          if (list[i].field !== fieldName) { continue; }

          for (key in list[i]) {
            if (list[i].hasOwnProperty(key)) {
              // If there is a field continue on and skip adding to keys array
              // We need this for when we respond to link back to originating field
              if (key === 'field') { continue; }
              // Only grab first key in object as it should be the validatorName
              keys.push(key);
              break;
            }
          }

          if (keys.length === 1) {
            // Expect the validator to be the first KEY in the array
            validatorName = keys[0];

            if (list[i][validatorName]) {

              // Get validator and give it the value
              if (list[i][validatorName].hasOwnProperty('message')) {
                customMessage = list[i][validatorName].message;
                if (list[i][validatorName].hasOwnProperty('test')) {
                  if (typeof(list[i][validatorName].test) === 'function') {
                    validatorValue = list[i][validatorName].test();
                  }else{
                    validatorValue = list[i][validatorName].test;
                  }
                }else{
                  validatorValue = false;
                  errors.push({
                    validator: validatorName,
                    message: 'No test to run for validator `' + validatorName + '`'
                  });
                }
              }else{
                validatorValue = list[i][validatorName];
              }

            }

            validatorFunc = this.getValidator(validatorName);

            // If there is a validator and it fails
            if (validatorFunc && !validatorFunc(validatorValue)) {
              errors.push({
                validator: validatorName,
                message: (customMessage) ? customMessage : 'Invalid `' + validatorName + '`',
                payload: list[i]
              });
            }else if (!validatorFunc) {
              // If the function is not found add an error
              errors.push({
                validator: validatorName,
                message: 'No validator `' + validatorName + '` exists',
                payload: list[i]
              });
            }
          }else{
            errors.push({
              validator: false,
              message: 'Validator not found.',
              payload: list[i]
            });
          }

        }

        return (errors.length === 0);

      },

      findError: function(validators, fieldName) {
        var i, ii,
          r = false;

        for (i=0,ii=validators.length;i<ii;i++) {
          if (validators[i].field === fieldName) {
            r = validators[i].message;
            break;
          }
        }

        return r;
      },

      addFieldTest: function(test) {
        var dupe = this.findDupe(test);

        if (!dupe) {
          this.tests.push(angular.copy(test));
        }else{
          this.tests[dupe.index] = test;
        }
      },

      addFieldTests: function(tests) {
        var i, ii;

        if (tests instanceof Array) {
          for (i=0,ii=tests.length;i<ii;i++) {
            this.addFieldTest(tests[i]);
          }
        }
      },

      removeFieldTest: function(test) {
        var i, ii;

        for (ii=0,i=this.tests.length - 1;i>=ii;i--) {
          if (this.tests[i].field === test.field) {
            this.tests.splice(i, 1);
            break;
          }
        }
      },

      clearFieldTests: function(test) {
        this.tests = [];
      },

      runFieldTests: function() {
        this.validate(this.tests);
      },

      findDupe: function(test) {
        var i, ii,
            r = false;

        for (ii=0,i=this.tests.length - 1;i>=ii;i--) {
          if (this.tests[i].field === test.field) {
            r = {
              test: this.tests[i],
              index: i
            };
            break;
          }
        }

        return r;
      },

      validators: {
        /**
         * Email validation function
         *
         * @param value {string}
         */
        email: function (value) {
          return emailValidator(value);
        },

        /**
         * Optional email validation function
         *
         * @param value {string}
         */
        optionalEmail: function (value) {
          if (isEmptyInputValue(value)) {
            return true;  // don't validate empty values to allow optional controls
          }

          return emailValidator(value);
        },

        /**
         * Not Email validation function
         *
         * @param value {string}
         */
        notEmail: function (value) {
          return !(/(^(?!\s))[-0-9a-zA-Z.+_']+@{1}[-0-9a-zA-Z.+_]+\.[a-zA-Z]{2,4}$/).test(value);
        },

        /**
         * Password validation
         *
         * @param value {string}
         */
        password: function (value) {
          var passwordPolicies = {
            passwordSecurityPolicyEnabled: ThemesHelperService.getCompany('passwordSecurityPolicyEnabled'),
            passwordMinimumLength: ThemesHelperService.getCompany('passwordMinimumLength'),
            passwordUseMixedCase: ThemesHelperService.getCompany('passwordUseMixedCase'),
            passwordMinimumDigits: ThemesHelperService.getCompany('passwordMinimumDigits'),
            passwordMinimumSymbols: ThemesHelperService.getCompany('passwordMinimumSymbols')
          };
          var r;

          if (!passwordPolicies.passwordMinimumLength || passwordPolicies.passwordMinimumLength < 8) {
            passwordPolicies.passwordMinimumLength = 8;
          }

          // Always check for length.
          r = (value && value.length >= passwordPolicies.passwordMinimumLength);

          if (passwordPolicies.passwordSecurityPolicyEnabled) {
            //test all policies
            if (passwordPolicies.passwordUseMixedCase) {
              r = r && ( /^(?=.*[a-z])(?=.*[A-Z]).+$/.test(value) );
            }

            if (passwordPolicies.passwordMinimumDigits) {
              r = r && ( (/^(?=.*\d).+$/).test(value) );
            }

            if (passwordPolicies.passwordMinimumSymbols) {
              r = r && ( (/^(?=.*[_\W]).+$/).test(value) );
            }
          }

          return r;
        },

        /**
         * Name String validation
         * Validate strings such as first, middle and last name
         *
         * @param value {string}
         */
        name: function (value) {
          var valid = false,
              testValue = (value) ? value : '';

          // Names should not begin with numbers
          if ((/[a-zA-Z\s]+/).test(testValue) &&
              (/^[\d]+/g).test(testValue) === false) {
            valid = true;
          }

          return valid;

        },

        /**
         * Numeric validation
         * @param value {string}
         */
        number: function (value) {
          return !isNaN(parseFloat(value)) && isFinite(value);
        },

        /**
         * Positive numeric validation
         * @param value {string}
         */
        positive: function (value) {
          return !isNaN(parseFloat(value)) && isFinite(value) && value > 0;
        },

        /**
         * numeric validation for a number that is greater than some value
         * @param props {{ actual: number; target: number; }}
         */
        greaterThan: function (props) {
          return !isNaN(parseFloat(props.actual)) && isFinite(props.actual) && props.actual > props.target;
        },

        /**
         * numeric validation for a number that is one or greater
         * @param value {string}
         */
        oneOrGreater: function (value) {
          return !isNaN(parseFloat(value)) && isFinite(value) && value >= 1;
        },

        /**
         * Positive numeric validation
         * @param value {string}
         */
        negative: function (value) {
          return !isNaN(parseFloat(value)) && isFinite(value) && value < 0;
        },

        /**
         * UTC Date validation
         * @param value {string}
         */
        utcDate: function(value) {
          var valid = false,
              testValue = (value) ? value : '';

          if ((/^\d{4}\-\d{2}\-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?((\-|\+)\d{2}:\d{2})?$/).test(testValue)) {
            valid = true;
          }
          return valid;
        },

        /**
         * Zip Code validation
         * @param value {String|Number}
         */
        zip: function (value) {
          var valid = false,
              testValue = (value) ? value : '';

          if ((/^\d{5}(-\d{4})?$/).test(testValue)) {
            valid = true;
          }

          return valid;
        },

        /**
         * Zip Code Validation
         * @param {Object} props
         * @returns {Boolean}
         */
        zipcode: function(props) {
          var value = props.value || '', 
              country = props.country || '', 
              required = props.required || false,
              valid = false,
              regex = false;

          switch (country.toLowerCase()) {
            case 'canada': regex = new RegExp('^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] +[0-9][A-Z][0-9]$', 'g'); break;
            default: regex = new RegExp('^\\d{5}(-\\d{4})?$');
          }

          valid = (
            (!required && !value.length) ||
            (required && value.length && !country.length) || 
            (regex.test(value))
          );

          return valid;
        },

        /**
         * Greater than validation with optional equalTo
         *
         * @param props {{
         *   greater: any;
         *   less: any;
         *   equalTo?: boolean;
         * }}
         * @returns {boolean}
         */
        greater: function(props) {
          var r = false;

          if (isNaN(parseFloat(props.greater)) && !isFinite(props.greater) || props.greater == null) {
            delete props.greater;
          }else if (typeof(props.greater) === 'string' && props.greater.replace(/s+/,'').length === 0) {
            delete props.greater;
          }
          if (isNaN(parseFloat(props.less)) && !isFinite(props.less) || props.less == null) {
            delete props.less;
          }else if (typeof(props.less) === 'string' && props.less.replace(/s+/,'').length === 0) {
            delete props.less;
          }

          if (props.equalTo) {
            r = (props.greater >= props.less);
          }else{
            r = (props.greater > props.less);
          }

          return r;
        },

        /**
         * Less than validation with optional equalTo
         *
         * @param props {{
         *   greater: any;
         *   less: any;
         *   equalTo?: boolean;
         * }}
         * @returns {boolean}
         */
        less: function(props) {
          var r = false;

          if (isNaN(parseFloat(props.greater)) && !isFinite(props.greater) || props.greater == null) {
            delete props.greater;
          }else if (typeof(props.greater) === 'string' && props.greater.replace(/s+/,'').length === 0) {
            delete props.greater;
          }
          if (isNaN(parseFloat(props.less)) && !isFinite(props.less) || props.less == null) {
            delete props.less;
          }else if (typeof(props.less) === 'string' && props.less.replace(/s+/,'').length === 0) {
            delete props.less;
          }

          if (props.equalTo) {
            r = (props.greater <= props.less);
          }else{
            r = (props.greater < props.less);
          }

          return r;
        },

        /**
         * Phone values
         *
         * @param value
         * @returns {boolean}
         */
        phone: function (value) {
          return phoneValidator(value);
        },

        /**
         * Optional phone validation function
         *
         * @param value
         * @returns {boolean}
         */
         optionalPhone: function (value) {
          if (isEmptyInputValue(value)) {
            return true;  // don't validate empty values to allow optional controls
          }

          return phoneValidator(value);
        },

        /**
         * Allows us to run arbitrary validators
         * @param props {{ predicateFn: (...args: any[]) => boolean }}
         * @returns {boolean}
         */
        predicate: function(props) {
          return props.predicateFn();
        },

        /**
         * Equal values with no type coercion
         *
         * Accepts:
         * [ value1, value2 ]
         *
         * @param values {Array}
         * @returns {boolean}
         */
        equal: function(values) {
          return values[0] === values[1];
        },

        /**
         * Non Equal Values
         *
         * Accepts:
         * [ value1, value2 ]
         *
         * @param values
         * @returns {*}
         */
        notEqual: function(values) {
          return this.equal(values) === false;
        },

        /**
         * OR validator for values
         *
         * Accepts:
         * {
         *   values: {Array}
         *   expected: {String|Number|boolean}
         * }
         * @param {object} props
         * @param {Array} props.values
         * @param {boolean} props.expected
         * @returns {boolean}
         */
        or: function(props) {
          var i, ii,
              r = false;

          if (props.values && props.values instanceof Array && props.hasOwnProperty('expected')) {
            for (i = 0, ii = props.values.length; i < ii; i++) {
              if (props.values[i] === props.expected) {
                r = true;
                break;
              }
            }
          }

          return r;

        },

        /**
         * Validates at least one of the values is present
         * @param {object} props
         * @param {Array<{ value: any }>} props.values
         * @returns {boolean}
         */
        oneOf: function(props) {
          return props.values.some(function(item) {
            return !!item.value;
          });
        },

        /**
         * Coupon code validator
         *
         * @param props
         * @returns {boolean}
         */
        coupon: function(props) {
          var regex = new RegExp(/^(.)+$/);
          return regex.test(props.code + '');
        },

        /**
         * Ensures strings are not empty
         *
         * Accepts:
         * {
         *   value: {String}
         *   minLength: {Integer}
         * }
         * @param props {Object}
         * @returns {boolean}
         */
        len: function(props) {
          var minLength = parseInt(props.minLength, 10) || 1;
          return (typeof(props.value) === 'string' && props.value.length > minLength - 1);
        },

        /**
         * Alphanumerical validator
         *
         * @param value {string}
         * @returns {Boolean}
         */
        alpha: function (value) {
          var val = (value) ? value : '';
          return (/^[A-Za-z\d\s]+$/).test(val);
        },

        dateAfterYesterday: function(date) {
          var millisInDay = 86400000,
              yesterday = new Date(new Date().getTime()-millisInDay);

          try {
            return date.value.getTime() > yesterday.getTime();
          } catch (e) {
            // invalid date
          }
          return false;

        }
      },

      // Error Array
      errors: []

    };
}]);